export default "<h5 class=\"ds-card__title\"><ng-content></ng-content></h5>\r\n";